import React, { useState, useEffect, useRef } from "react"
import Layout from '../layouts/index'

export default function Omacro({ children, location }) {
    const [isOmacroLoaded, setIsOmacroLoaded] = useState(false)
    const omacroNode = useRef(null)

    const createOmacroScript = () => {
        const url = 'https://buynow.omacro.com/embedded/bn.loader.js'
        const company = 'c952d218-8526-4f22-ae69-babb10f7f711'
        const validate = false
        const debug = false
        // const country = 'auto'

        const script = document.createElement("script")
        script.id = "omacro-widget-buynow"
        script.src = `${url}?company=${company}&validate=${validate}&debug=${debug}`
        script.async = true
        return script
    }
    
    const handlePreRouteUpdate = ({ detail }) => {
        const { location, prevLocation } = detail

        const from = prevLocation.pathname
        const to = location.pathname

        if (to === '/dealers/') {
            omacroNode.current.remove()
        }

        if (from === '/dealers/') {
            document.body.prepend(omacroNode.current)
        }
    }

    const mutationCallback = (mutationList, observer) => {
        mutationList.forEach(mutation => {
            const { type, addedNodes } = mutation
            if (type !== "childList") return
            
            addedNodes.forEach(node => {
                // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
                if (node.nodeType !== 1) return

                // update tracked element
                if (node.matches('.oma-omacro')) {
                    omacroNode.current = node
                }
            })
        })
    }

    const observeMutations = () => {
        const observer = new MutationObserver(mutationCallback)
        observer.observe(document.body, { attributes: true, childList: true, subtree: true })
        return observer
    }

    useEffect(() => {
        if (typeof window === 'undefined' || typeof document === 'undefined') return
        
        const observer = observeMutations()
        const script = createOmacroScript()
        const handler = () => setIsOmacroLoaded(true)
        
        document.head.appendChild(script)
        document.body.addEventListener('loaded.omacro.buynow', handler)
        window.addEventListener('PRE_ROUTE_UPDATE', handlePreRouteUpdate)

        return () => {
            window.removeEventListener('PRE_ROUTE_UPDATE', handlePreRouteUpdate)
            document.head.removeChild(script)
            document.body.removeEventListener('loaded.omacro.buynow', handler)
            observer.disconnect()
        }
    }, [])

    useEffect(() => {
        if (typeof document === 'undefined' || typeof window === 'undefined' || !isOmacroLoaded || !omacroNode.current) return

        const { omacro: { buynow: { widget } } } = window
        const { search, pathname } = location

        if (pathname === '/dealers/') {
            widget.settings.embedded = true
            document.getElementById('dealers-page').appendChild(omacroNode.current)

            const params = new URLSearchParams(search)
            switch (params.get('l')) {
                case 'distributor':
                    widget.dealerMode = 'distributor'
                    widget.settings.params.mode = 'distributor'
                    widget.mode('distributor')
                    widget.showDistributors()
                    break;
                case 'local':
                    widget.dealerMode = 'retailer'
                    widget.settings.params.mode = 'retailer'
                    widget.mode('retailer')
                    widget.show('*', 'local', 'us')
                    break;
                default:
                    widget.dealerMode = 'retailer'
                    widget.settings.params.mode = 'retailer'
                    widget.mode('retailer')
                    widget.show('*', 'online', 'us')
                    break;
            }
        } else {
            widget.settings.embedded = false
            widget.dealerMode = 'retailer'
            widget.settings.params.mode = 'retailer'
            widget.settings.markets.online.showLocalInv = true
            widget.mode('retailer')
        }
    }, [location, isOmacroLoaded, omacroNode.current])

    return <Layout>{children}</Layout>
}
